import React, { useEffect, useState } from 'react';
import AnimatedLetters from './AnimatedLetters';
import Loader from 'react-loaders';
import HTML from '../assets/html.png';
import CSS from '../assets/css.png';
import JavaScript from '../assets/javascript.png';
import ReactImg from '../assets/react.png';
import Node from '../assets/node.png';
import GitHub from '../assets/github.png';
import Tailwind from '../assets/tailwind.png';
import N8n from '../assets/skills/n8n.svg';
import Zapier from '../assets/skills/zapier.svg';
import Make from '../assets/skills/make.svg';
import HubSpot from '../assets/skills/hubspot.svg';
import Airtable from '../assets/skills/airtable.svg';
import GoogleAppsScript from '../assets/skills/googleappsscript.svg';
import GoHighLevel from '../assets/skills/gohighlevel.svg';
import Monday from '../assets/skills/monday.svg';
import Prismatic from '../assets/skills/prismatic.svg';
import Python from '../assets/skills/python.svg';
import ChatGPT from '../assets/skills/chatgpt.svg';
import Claude from '../assets/skills/claude.svg';
import Gemini from '../assets/skills/gemini.svg';

const Skills = () => {

    const [letterClass, setLetterClass] = useState('text-animate-underline')

    useEffect(() =>{
        setTimeout(() =>{
            setLetterClass('text-animate-underline-hover')
        }, 3000)
    }, [])

  return (
    <>
    <div name='skills' className='w-full bg-[#0a192f] text-gray-300 overflow-auto scroll-mt-20'>
      {/* Container */}
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
          <div className='pb-8 mt-20'>
              <p className='text-4xl font-bold skill-page'><AnimatedLetters className
                        letterClass={letterClass}
                        strArray={['S', 'k', 'i' , 'l', 'l', 's']}
                        idx={10}
                    /></p>
              {/* eslint-disable-next-line */}
              <p className='py-4 text-animation'>These are the programming languages, frameworks, and technologies with which I've got expertise.</p>
          </div>

          {/* Automation & No-Code Tools */}
          <p className='text-xl font-semibold text-[#ffd700] pb-2 text-animation'>Automation &amp; No-Code Tools</p>
          <div className='w-full grid grid-cols-3 sm:grid-cols-5 gap-4 text-center py-4 text-animation'>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-14 mx-auto' src={N8n} alt="n8n icon" />
                  <p className='my-4'>N8N</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-14 mx-auto' src={Zapier} alt="Zapier icon" />
                  <p className='my-4'>ZAPIER</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-14 mx-auto' src={Make} alt="Make icon" />
                  <p className='my-4'>MAKE</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-14 mx-auto' src={HubSpot} alt="HubSpot icon" />
                  <p className='my-4'>HUBSPOT</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-14 mx-auto' src={Airtable} alt="Airtable icon" />
                  <p className='my-4'>AIRTABLE</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-14 mx-auto' src={GoogleAppsScript} alt="Google Apps Script icon" />
                  <p className='my-4'>APPS SCRIPT</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-14 mx-auto' src={GoHighLevel} alt="GoHighLevel icon" />
                  <p className='my-4'>GOHIGHLEVEL</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-14 mx-auto' src={Monday} alt="Monday icon" />
                  <p className='my-4'>MONDAY</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-14 mx-auto' src={Prismatic} alt="Prismatic icon" />
                  <p className='my-4'>PRISMATIC</p>
              </div>
          </div>

          {/* AI Tools */}
          <p className='text-xl font-semibold text-[#ffd700] pb-2 text-animation'>AI Tools</p>
          <div className='w-full grid grid-cols-3 sm:grid-cols-4 gap-4 text-center py-4 text-animation'>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-14 mx-auto' src={ChatGPT} alt="OpenAI icon" />
                  <p className='my-4'>OPENAI</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-14 mx-auto' src={Claude} alt="Claude icon" />
                  <p className='my-4'>CLAUDE</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-14 mx-auto' src={Gemini} alt="Gemini icon" />
                  <p className='my-4'>GEMINI</p>
              </div>
          </div>

          {/* Tech Stack */}
          <p className='text-xl font-semibold text-[#ffd700] pb-2 text-animation'>Tech Stack</p>
          <div className='w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-4 text-animation'>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-20 mx-auto' src={HTML} alt="HTML icon" />
                  <p className='my-4'>HTML</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-20 mx-auto' src={CSS} alt="CSS icon" />
                  <p className='my-4'>CSS</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-20 mx-auto' src={JavaScript} alt="JavaScript icon" />
                  <p className='my-4'>JAVASCRIPT</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-20 mx-auto' src={Python} alt="Python icon" />
                  <p className='my-4'>PYTHON</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-20 mx-auto' src={ReactImg} alt="React icon" />
                  <p className='my-4'>REACT</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-20 mx-auto' src={GitHub} alt="GitHub icon" />
                  <p className='my-4'>GITHUB</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-20 mx-auto' src={Node} alt="Node JS icon" />
                  <p className='my-4'>NODE JS</p>
              </div>
              <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 pt-5'>
                  <img className='w-20 mx-auto' src={Tailwind} alt="Tailwind icon" />
                  <p className='my-4'>TAILWIND</p>
              </div>
          </div>
      </div>
    </div>
    <Loader type="pacman" />
    </>
  )
}

export default Skills
